<template>
  <div v-if="items.length > 0">
    <div class="table-of-contents subheading">
      <span v-if="title" class="table-of-contents__title" v-text="title" />

      <img
        class="lazyload "
        v-if="image"
        :alt="image.alt"
        :height="image.height"
        :data-src="image.src"
        :width="image.width"
      />

      <ol
        class="table-of-contents__list"
        :class="{ '-split': displayTwoColumns }"
        :style="`--indexes-length: ${items.length}`"
      >
        <li v-for="item in items" :key="item.href" class="table-of-contents__item">
          <a :href="`#${item.href}`" v-text="item.label" />
        </li>
      </ol>
    </div>

    <hr class="table-of-contents__divider" />
  </div>
</template>

<script>
export default {
  name: 'TableOfContents',

  props: {
    image: {
      default: null,
      type: Object,
    },
    targetContext: {
      default: '.rich-text',
      type: String,
    },
    targetHeading: {
      default: 'h2',
      type: String,
    },
    title: {
      default: null,
      type: String,
    },
  },

  data: () => ({
    items: [],
  }),

  computed: {
    displayTwoColumns() {
      return this.items && this.items.length > 5;
    },
  },

  mounted() {
    const textBlocks = document.body.querySelectorAll(this.targetContext);
    let id = 0;

    textBlocks.forEach((block) => {
      const listOfBlockHeadings = block.querySelectorAll(this.targetHeading);

      listOfBlockHeadings.forEach((heading) => {
        if (!heading.innerText || !heading.innerText.length) {
          return;
        }

        heading.id = id;

        this.items = [...this.items, {
          href: id,
          label: heading.innerText,
        }]

        id++;
      });
    });
  },
};
</script>
